module.exports = __webpack_public_path__ + "img/logo.6e822ea6.png";